module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Share_16"],"path":[{"$":{"d":"M12.75,10.5a2.23,2.23,0,0,0-1.7.79L5.43,8.52a2.06,2.06,0,0,0,0-1L11,4.67a2.24,2.24,0,1,0-.52-1.42,2.23,2.23,0,0,0,.07.53L5,6.58A2.25,2.25,0,1,0,5,9.41l5.6,2.76a2.24,2.24,0,1,0,2.17-1.67Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Share_16.svg
// module id = E8MS
// module chunks = 1